import { get } from "../../utils/objectHelpers";

<if(state && state.tabs.length)>
     <div class="str-tablist" key="str-tablist" role="tablist" on-keydown("handleKeydown")>
        <for|tab, idx| of=state.tabs>
            $ {
                 const isSelected = idx === state.selectedIndex ? true : false;
            }
            <div on-click("selectTab", idx)
                role="tab"
                tabindex=`${isSelected ? 0 : -1}`
                aria-selected=`${isSelected}`
                aria-controls=tab.panelId
                id=tab.tabId>
                
                <str-textual-display ...tab />
                <div class="hidden-bold-text">
                    <!-- Used to prevent small movement when the text is bolded on-hover -->
                    <span>${tab.textSpans[0].text}</span>
                </div>                
            </div>
        </for>
    </div>
</if>
